import { ReactComponent as Associations } from '../assets/complex-icons/associations.svg';
import { ReactComponent as BoxFinish } from '../assets/complex-icons/box-finish.svg';
import { ReactComponent as Boxes } from '../assets/complex-icons/boxes.svg';
import { ReactComponent as Chat } from '../assets/complex-icons/complex-chat.svg';
import { ReactComponent as Check } from '../assets/complex-icons/complex-check.svg';
import { ReactComponent as Calendar } from '../assets/complex-icons/complex-calendar.svg';
import { ReactComponent as Computer } from '../assets/complex-icons/computer.svg';
import { ReactComponent as Config } from '../assets/complex-icons/config.svg';
import { ReactComponent as Destination } from '../assets/complex-icons/destination.svg';
import { ReactComponent as DevDom } from '../assets/complex-icons/dev-a-dom.svg';
import { ReactComponent as DevPunto } from '../assets/complex-icons/dev-a-punto.svg';
import { ReactComponent as DevSameday } from '../assets/complex-icons/dev-sameday.svg';
import { ReactComponent as Error } from '../assets/complex-icons/error.svg';
import { ReactComponent as General } from '../assets/complex-icons/general.svg';
import { ReactComponent as HubPoint } from '../assets/complex-icons/hub-point.svg';
import { ReactComponent as InDeposit } from '../assets/complex-icons/in-deposit.svg';
import { ReactComponent as Pending } from '../assets/complex-icons/pending.svg';
import { ReactComponent as Point } from '../assets/complex-icons/point.svg';
import { ReactComponent as StockControl } from '../assets/complex-icons/stock-control.svg';
import { ReactComponent as ThreeBoxes } from '../assets/complex-icons/three-boxes.svg';
import { ReactComponent as Transactions } from '../assets/complex-icons/transactions.svg';
import { ReactComponent as TruckDelivery } from '../assets/complex-icons/truck-delivery.svg';
import { ReactComponent as Warning } from '../assets/complex-icons/warning-complex.svg';
import { ReactComponent as Bike } from '../assets/complex-icons/bicicleta.svg';
import { ReactComponent as CancelledBox } from '../assets/complex-icons/caja-cancelada.svg';
import { ReactComponent as CancelledBoxes } from '../assets/complex-icons/cajas-canceladas.svg';
import { ReactComponent as Document } from '../assets/complex-icons/documento-en-revision.svg';
import { ReactComponent as MotoWithBox } from '../assets/complex-icons/moto-caja.svg';
import { ReactComponent as Moto } from '../assets/complex-icons/moto.svg';

export const icons = {
  associations: { name: 'Puntos', component: Associations },
  'box-finish': { name: 'Caja OK', component: BoxFinish },
  boxes: { name: 'Paquetes', component: Boxes },
  chat: { name: 'Preguntas', component: Chat },
  check: { name: 'Éxito', component: Check },
  calendar: { name: 'Proceso agendado', component: Calendar },
  computer: { name: 'Monitor', component: Computer },
  config: { name: 'Tuerca', component: Config },
  destination: { name: 'Domicilio', component: Destination },
  'dev-a-dom': { name: 'Devolución a domicilio', component: DevDom },
  'dev-a-punto': { name: 'Devolución a punto', component: DevPunto },
  'dev-sameday': { name: 'Calendario', component: DevSameday },
  error: { name: 'Cancelar', component: Error },
  general: { name: 'Info', component: General },
  'in-deposit': { name: 'Cajas OK', component: InDeposit },
  'hub-point': { name: 'Drop off', component: HubPoint },
  pending: { name: 'Cajas', component: Pending },
  point: { name: 'Punto', component: Point },
  'stock-control': { name: 'Control de paquetes', component: StockControl },
  'three-boxes': { name: 'Paquetes por tres', component: ThreeBoxes },
  transactions: { name: 'Devolución', component: Transactions },
  'truck-delivery': { name: 'Camión', component: TruckDelivery },
  warning: { name: 'Alerta', component: Warning },
  bike: { name: 'Bicicleta', component: Bike },
  'cancelled-box': { name: 'Caja cancelada', component: CancelledBox },
  'cancelled-boxes': { name: 'Cajas canceladas', component: CancelledBoxes },
  document: { name: 'Documento en revisión', component: Document },
  motorbike: { name: 'Moto', component: Moto },
  'motorbike-with-box': { name: 'Moto + caja', component: MotoWithBox },
};
